const preloadBody = () => {
  document.addEventListener('DOMContentLoaded', () => {
    document.body.classList.remove('preload');
  });
};

export { preloadBody };
